/* @flow */

import React, { Component } from 'react';
import glamorous from 'glamorous';
import colorUtils from 'color';
import { padding } from 'polished';
import Tappable from 'app/components/commons/Tappable';
import Glyph from 'app/components/commons/Glyph';

type Props = {
  children?: any,
  onClose: () => void,
  title: string,
  transitionDuration?: number,
};

type State = {
  closed: boolean,
};

const Outer = glamorous.div(({ theme, closed, transitionDuration }) => ({
  opacity: closed ? 0 : 1,
  overflow: 'hidden',
  transitionDuration: `${transitionDuration}ms`,
  transform: closed ? 'scale(0)' : null,
  transformOrigin: 'right top',
  textTransform: 'uppercase',
  backgroundColor: colorUtils(theme.color.panel)
    .alpha(0.6)
    .toString(),
  color: theme.color.panelAccent,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '10px 10px 0 0',
  textAlign: 'center',
  padding: theme.spacing.small,
  position: 'relative',
}));

const Content = glamorous.div(props => ({
  fontSize: props.theme.fontSize.default,
  lineHeight: 1.4,
  ...padding('0.25rem', '1rem'),
  textAlign: 'center',
}));

const CloseButton = glamorous(Tappable)(
  {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    position: 'absolute',
    right: 0,
    textAlign: 'center',
    top: 0,
    width: 50,
    height: 50,
    '&:hover, &:focus': {
      opacity: 0.5,
    },
    '&:active': {
      opacity: 0.5,
      transform: 'scale(0.8)',
    },
  },
  ({ theme }) => ({
    color: theme.color.panelAccent,
  }),
);

const Title = glamorous.div(props => ({
  fontSize: props.theme.fontSize.large,
  paddingTop: props.theme.spacing.small,
  textAlign: 'center',
  textTransform: 'uppercase',
}));

class Instructions extends Component<Props, State> {
  props: Props;

  state: State = {
    closed: false,
  };

  ref: HTMLElement; // eslint-disable-line react/sort-comp

  static defaultProps = {
    children: undefined,
    transitionDuration: 500,
  };

  handleClose = () => {
    const { onClose, transitionDuration } = this.props;
    this.setState({
      closed: true,
    });
    window.setTimeout(onClose, transitionDuration);
  };

  render() {
    const { children, title, transitionDuration } = this.props;
    const { closed } = this.state;

    return (
      <Outer closed={closed} transitionDuration={transitionDuration}>
        <Title>{title}</Title>
        <Content>{children}</Content>
        <CloseButton onTap={this.handleClose}>
          <Glyph icon="ios-close-empty" size="medium" />
        </CloseButton>
      </Outer>
    );
  }
}

export default Instructions;
